<template>
  <div>
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="AddGalex">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表  show-summary :summary-method="getSummaries"  -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" prop="uId" label="uId">
      </el-table-column>
      <el-table-column align="center" prop="userName" label="用户名">
      </el-table-column>
      <!-- <el-table-column align="center" label="是否禁用">
        <template slot-scope="scope">
          <el-row v-if="scope.row.disable">
              <el-button size="mini" type="success" @click="onDisable(scope.row.disable,scope.row)">允许</el-button>
              <span>禁止</span>
            </el-row>
            <el-row v-if="!scope.row.disable">
              <span>允许</span>
              <el-button size="mini" type="danger" @click="onDisable(scope.row.disable,scope.row)">禁止</el-button>
            </el-row>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="setupTime" label="创建时间">
      </el-table-column>
      
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 添加Galex -->
    <el-dialog title="添加" :visible.sync="addGalexVisible" width="30%"
      @click="addGalexVisible = false">
      <el-form :model="editForm" :rules="Rules" ref="editForm">
        <el-form-item label="用户名" prop="userName">
          <el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addGalexVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitUser('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { c2cUsers, c2cAddC2CUser, c2cDisableSwitch } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      // rules表单验证
      formInline: {
        from: 1,
        limit: 10,
      },
      addGalexVisible: false,
      editForm: {
        "userName": "",
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      Rules: {
        spaceId: [{ required: true, message: '请输入空间ID', trigger: 'blur' }],
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      c2cUsers(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    //Galex显示编辑界面
    AddGalex() {
      this.editForm = {
        "userName": "",
      }
      this.addGalexVisible = true
    },
    // 添加
    submitUser(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.loading = true
          c2cAddC2CUser(this.editForm)
            .then(res => {
              this.loading = false
              this.addGalexVisible = false
              if (res.code == 0) {
                console.log(res)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            }).catch(err => {
              this.addGalexVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
        }
      })
    },
    onDisable(falg,row){
      
        this.$confirm(falg?'是否启用':'是否禁用', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          c2cDisableSwitch({uId:row.id}).then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.getdata(this.formInline)
          }
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
      
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage - 1) * (this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    }
  }
}
</script>
  
<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/c2c/user.vue